module.exports = __webpack_public_path__ + "static/media/ferrarilarge.8cc972cd.jpg";